angular.module('tcApp')
.service('EventService', function($window, TimelineService, OverlayService) {
	var d3 = $window.window.d3;
	var svgNS = 'http://www.w3.org/2000/svg';
	var dimensions = {
		barThickness: 7.5,
		barBorder: 0.75,
		markerSize: 7.5,
		markerBorder: 0.75,
		selectionBorderThickness: 3, // thickness of border around popover selection
		labelGap: 2.5, // gap between item label and item
		labelBorderWidth: 0.5, // thickness of label border and line 
		labelTextPadding: 2, // padding around label text
		densityMarkerOverlapRatio: 0.33 // portion of a second marker that will be showing when data is hidden
	};
	var EventType = 'Event';
	var IntervalType = 'Interval';
	var CeasedStatus = 'CeasedStatus';
	var MixedStatus = 'MixedStatus';
	
	var getItemsByTimeRange = function(items, startTime, endTime, timeNow, timelineType) {
		var itemsInRange = [];
		angular.forEach(items, function(item) {
			if (timelineType === TimelineService.EventTimelineType && !item.visible) {
				return;
			}

			if (item.type === IntervalType) {
				var itemEndTime = (item.endTime === '') ? timeNow : item.endTime;
				if ((item.startTime <= endTime) && (itemEndTime >= startTime)) itemsInRange.push(item);
			} else if (item.type === EventType) {
				angular.forEach(item.eventItems, function(eventItem) {
					if ((eventItem.eventTime <= endTime) && (eventItem.eventTime >= startTime)) {
						itemsInRange.push(angular.extend({}, eventItem, {'type': item.type}));
					}
				});
			}
		});
		return itemsInRange;
	};
	
	// Create double diamond indicator
	var createIndicator = function(d, points, densityRatio, size) {
		// Create a indicator composed of a back diamond and front diamond. 
		// The back diamond appears when there is data density. It will look like 2 overlapping diamonds. 
		var element = d3.select($window.document.createElementNS(svgNS, 'g'));
		element.append('polygon') // Diamond in the back
			.attr('points', points)
			.attr('transform', 'translate(0,' + (-(1 - densityRatio) * (size / 2)) + ')')
			.attr('class', 'back');
		element.append('polygon') // Diamond in front
			.attr('points', points)
			.attr('class', 'front');
		return element.node();
	};

	// Get the back diamond of the indicator's style class
	var getBackDiamondClass = function(d, color) {
		var styleClass = '';
		if (d.dataHidden) {
			if (angular.isUndefined(color)) {
				// Colors are undefined. Use style class to set the colors (Order Timeline)
				styleClass = 'orderMarkerActive';
				if (angular.isDefined(d.status)) {
					if ((d.status == CeasedStatus) ||  (d.status == MixedStatus)) {
						styleClass = 'orderMarkerCeased';
					} 
				}
			}
			styleClass += ' markerVisible';
		} else {
			if (angular.isUndefined(color)) {
				// Colors are undefined. Use style class to set the colors (Order Timeline)
				styleClass = 'orderMarkerActive';
			}
			// There is no data hidden, the back diamond is transparent
			styleClass += ' markerTransparent'; 
		}	
		styleClass += ' back';
		return styleClass;
	};

	// Get the front diamond of the indicator's style class
	var getFrontDiamondClass = function(d, color) {
		var styleClass = '';
		if (angular.isUndefined(color)) {
			// Colors are undefined. Use style class to set the colors (Order Timeline)
			styleClass = 'orderMarkerActive';
			if (angular.isDefined(d.status)) {
				if (d.status == CeasedStatus) {
					styleClass = 'orderMarkerCeased';
				} 
			}
		}
		styleClass += ' front markerVisible';
		return styleClass;
	};

	var getFillColor = function(color) {
		if (angular.isDefined(color)) {
			return color;
		} else {
			return '';
		}
	};

	var sendToFront = function(target, parent) {
		parent.node().appendChild(target.node());
	};
	
	var getEventItemGroupId = function(eventItem, parent) {
		return parent.attr('id') + '-eventItemGroup_' + eventItem.htmlId;
	};
	
	var getLabelGroupId = function(itemGroup) {
		return itemGroup.attr('id') + '-label';
	};
	
	var getLabelClipPathId = function(labelGroupId) {
		return labelGroupId + 'ClipPath';
	};
	
	var addLabelData = function(valueData, itemData) {
		if (angular.isUndefined(valueData)) return;
		if ((angular.isUndefined(itemData)) || (!angular.isObject(itemData))) return;
		
		removeLabelData(valueData, itemData.labelGroupId);
					
		var insertIndex = valueData.findIndex(function(element) {return element.labelX > itemData.labelX;});
		if (insertIndex === -1) insertIndex = valueData.length;
		valueData.splice(insertIndex, 0, itemData);
	};
	
	var removeLabelData = function(valueData, labelGroupId) {
		if ((angular.isUndefined(valueData)) || (angular.isUndefined(labelGroupId))) return;
		var removeIndex = valueData.findIndex(function(element) {return element.labelGroupId === labelGroupId;});
		if (removeIndex === -1) return;
		valueData.splice(removeIndex, 1);
	};
	
	this.serviceOnDisplay = function($scope, ctrl, axisGroup) {
		var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
		axisGroupModel.labelData = {};
		
		var popoverSelectionXOffset = dimensions.selectionBorderThickness / 2;
		var popoverSelectionYOffset = dimensions.selectionBorderThickness / 2;
		var popoverSelectionY = 1 + popoverSelectionYOffset;
		var scrollableContainer = axisGroup.getDataSvgContainer();
		scrollableContainer.append('rect')
			.classed('popoverSelection', true)
			.attr('id', axisGroup.htmlIdPrefix + '-popoverSelection')
			.attr('x', 0)
			.attr('y', popoverSelectionY)
			.attr('stroke-width', dimensions.selectionBorderThickness + 'px');
		
		var popoverHandler = function() {
			if ($scope.data.profileType === TimelineService.EventTimelineType) {
				eventItemHideTooltip($scope, axisGroup);
			}

			var mouseTime = $scope.tcXScale.invert(d3.mouse(scrollableContainer.node())[0]);
			var selectionTimes = TimelineService.getColumnTimes(mouseTime, $scope.tcTimeInterval);
			var selectionStart = ctrl.getXCoordinateFromTime(selectionTimes[0]);
			var selectionEnd = ctrl.getXCoordinateFromTime(selectionTimes[1]);
			
			var selectedItems = getItemsByTimeRange(axisGroup.yAxes[0].items, selectionTimes[0], 
								selectionTimes[1], $scope.tcTimeNow, $scope.data.profileType);
			if (selectedItems.length === 0) return;
			
			var popoverSelection = scrollableContainer.select('rect.popoverSelection')
				.attr('x', selectionStart + popoverSelectionXOffset)
				.attr('width', selectionEnd - selectionStart - 2 * popoverSelectionXOffset)
				.attr('height', axisGroupModel.dimensions.height - popoverSelectionY - popoverSelectionYOffset)
				.style('opacity', 1);
			sendToFront(popoverSelection, scrollableContainer);
			
			var ItemsDataJSON = encodeURIComponent(angular.toJson(selectedItems)); // Encode URI before passing it to popoverParams
			var popoverParams = axisGroup.popoverParams + '&ItemsData=' + ItemsDataJSON;
			
			$scope.$emit('Timeline:pauseAutoRefresh', {reason: 'Popover'});

			var overlayOptions = {
				event: d3.event,
				componentName: 'system.Timeline.EventTimeline.Popover',
				params: popoverParams,
				popoverFor: popoverSelection.attr('id'),
				onRemovingHandler: function() {
					popoverSelection.style('opacity', 0);
					$scope.$emit('Timeline:playAutoRefresh', {reason: 'Popover'});
				}
			};
			OverlayService.open(overlayOptions);
		};
		
		axisGroup.getMainGraphSvg().on('click', popoverHandler);
	};
	
	this.getStyleAxisTicks = function() {
		var styleAxisTicks = function(g) {
			g.selectAll('.tick text').text('');
		};
		
		return styleAxisTicks;
	};
	
	var eventItemHideTooltip = function($scope, axisGroup) {
		var tooltip = axisGroup.getTooltip();
		if (!tooltip.html()) return;
		tooltip.transition()		
			.duration($scope.viewModel.transitionDuration)
			.style('opacity', 0);
	};
	
	this.getDrawAxisItemData = function($scope, ctrl, axisGroup) {
		var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
		// draws a label in the given itemGroup with the given options
		// options:
		// - show: draw the label if true, hide the label if false or unspecified
		// - target: x and y coordinates of the bottom tip of the label
		// - caption: text to display in the label
		// - borderClass: css class to be applied against the label line and shape (but not the text)
		// - textClass: css class to be applied against the label text (but not the line or shape)
		// - showLine: if true, draws a line between the target and the label shape;
		//    otherwise, no line is drawn
		// - arrowRatio: determines size of the arrow, as a ratio of the arrow's 
		//    length to the height of the attached rectangle
		//
		// itemData is used to update labelData and contains the following:
		// - value: indicates the row in which the label is being displayed
		// - labelX: the x-position of the left edge of the label
		//
		// labelData is an object whose keys are the values of the itemData objects
		// - Stored against each key is an array of itemData objects, sorted by labelX ascending
		// - Each itemData object additionally has a labelGroupId property, added as labels are drawn
		var showHideItemLabel = function(itemGroup, itemData, labelData, options) {
			if (!angular.isObject(options)) options = {};
			
			var labelGroupId = getLabelGroupId(itemGroup);
			var labelGroup = TimelineService.getOrCreateSvgElementById(labelGroupId, 'g', itemGroup);
				
			var labelLine = TimelineService.getOrCreateSvgElementByType('line', labelGroup);
			var textBoxGroup = TimelineService.getOrCreateSvgElementByType('g', labelGroup);
			var labelShape = TimelineService.getOrCreateSvgElementByType('polygon', textBoxGroup);
			var labelText = TimelineService.getOrCreateSvgElementByType('text', textBoxGroup);
			
			if (options.show) {
				labelText.attr('visibility', 'visible')
					.attr('class', options.textClass)
					.text(options.caption);
				var textBox = labelText.node().getBBox();
				
				var target = options.target;
				if (!angular.isObject(target)) target = {x: 0, y: 0};
				
				var lineX = target.x + dimensions.labelBorderWidth / 2;
				var lineY1 = target.y;
				var lineY2 = lineY1 - dimensions.labelGap;
				if (options.showLine) {
					labelLine.attr('visibility', 'visible')
						.attr('x1', lineX)
						.attr('x2', lineX)
						.attr('y1', lineY1)
						.attr('y2', lineY2)
						.attr('class', options.borderClass)
						.attr('stroke-width', dimensions.labelBorderWidth);
				} else {
					labelLine.attr('visibility', 'hidden');
				}
				
				if (angular.isUndefined(options.arrowRatio)) options.arrowRatio = 0;
				var shapeHeight = textBox.height + 2 * dimensions.labelTextPadding;
				var arrowHeight = shapeHeight * options.arrowRatio;
				var shapeWidth = textBox.width + 2 * dimensions.labelTextPadding + dimensions.labelBorderWidth + arrowHeight;
				var shapeX = lineX;
				var shapeY = lineY2;
				var shapePoints = '0,' + (-shapeHeight / 2)
									+ ' ' + arrowHeight + ',' + (-shapeHeight)
									+ ' ' + shapeWidth + ',' + (-shapeHeight)
									+ ' ' + shapeWidth + ',0'
									+ ' ' + arrowHeight + ',0';
				labelShape.attr('visibility', 'visible')
					.attr('points', shapePoints)
					.attr('transform', 'translate(' + shapeX + ', ' + shapeY + ')')
					.attr('class', options.borderClass)
					.attr('stroke-width', dimensions.labelBorderWidth);
				
				var textX = shapeX + dimensions.labelBorderWidth + dimensions.labelTextPadding + arrowHeight;
				var textY = shapeY - dimensions.labelBorderWidth - 1.5 * dimensions.labelTextPadding;
				labelText.attr('x', textX)
					.attr('y', textY);
				
				var totalLabelHeight = dimensions.labelGap + shapeHeight + dimensions.labelBorderWidth;
				itemGroup.attr('transform', 'translate(0, ' + (totalLabelHeight / 2) + ')');
				
				// update label data and clip path
				itemData.labelGroupId = labelGroupId;
				
				if (angular.isUndefined(labelData[itemData.value])) labelData[itemData.value] = [];
				var valueData = labelData[itemData.value];
				
				// check if label data already exists
				// if so, remove it to avoid duplicates and incorrect ordering
				addLabelData(valueData, itemData);
				
				var clipPathId = getLabelClipPathId(labelGroupId);
				var clipPath = TimelineService.getOrCreateSvgElementById(clipPathId, 'clipPath', labelGroup);
				var clipPathRect = TimelineService.getOrCreateSvgElementByType('rect', clipPath);
				
				var labelBBox = labelShape.node().getBBox();
				var labelClientRect = labelShape.node().getBoundingClientRect();
				var xOffset = (labelClientRect.width - labelBBox.width) / 2;
				var yOffset = (labelClientRect.height - labelBBox.height) / 2;
				clipPathRect.attr('x', labelBBox.x - xOffset)
					.attr('y', labelBBox.y - yOffset)
					.attr('height', labelClientRect.height)
					.attr('transform', labelShape.attr('transform'));
				textBoxGroup.attr('clip-path', 'url(#' + clipPathId + ')');
			} else {
				// hide the label
				labelText.attr('visibility', 'hidden');
				labelLine.attr('visibility', 'hidden');
				labelShape.attr('visibility', 'hidden');
				itemGroup.attr('transform', '');
				
				// update label data
				removeLabelData(labelData[itemData.value], labelGroupId);
			}
		};
		
		var eventItemMouseoverHandler = function(target, parent) {
			if ($scope.viewModel.showLabels) {
				var targetId = target.attr('id');
				var targetMarker = parent.select('#' + targetId + ' > polygon');
				
				targetMarker.classed('labelHighlight', true);
				
				var labelGroupId = getLabelGroupId(target);
				var labelTextBox = target.select('#' + labelGroupId + ' > g');
				labelTextBox.attr('clip-path', '');
				
				target.selectAll('.labelBorder')
					.classed('labelHighlight', true);
				
				sendToFront(target, parent);
			}

			if ($scope.data.profileType === TimelineService.EventTimelineType) {
				var itemData = target.data()[0];

				var tooltip = axisGroup.getTooltip();
				var tooltipHtml = '';
				if (itemData.tooltipTitle) {
					tooltipHtml += '<b>' + itemData.tooltipTitle + '</b> ';
				}
				if (itemData.tooltipStartEndDateTimes) {
					tooltipHtml += '<br>' + itemData.tooltipStartEndDateTimes;
				}
				if (itemData.tooltipBody) {
					angular.forEach(itemData.tooltipBody, function (commentLine) {
						tooltipHtml += '<br>' + commentLine;
					});
				}
				if (tooltipHtml === '') {
					return;
				}

				tooltip.transition()		
					.duration(200)
					.style('opacity', 1);
				tooltip.html(tooltipHtml);
				tooltip.style('left', (d3.event.pageX) + 'px')
					.style('top', (d3.event.pageY) + 'px');
			}
		};
		
		var eventItemMouseoutHandler = function(target) {
			var labelGroupId = getLabelGroupId(target);
			var labelTextBox = target.select('#' + labelGroupId + ' > g');
			labelTextBox.attr('clip-path', 'url(#' + getLabelClipPathId(labelGroupId) + ')');
			
			target.selectAll('.labelHighlight')
				.classed('labelHighlight', false);
			
			if ($scope.data.profileType === TimelineService.EventTimelineType) {
				eventItemHideTooltip($scope, axisGroup);
			}
		};
		
		var drawAxisItemData = function(axis, axisSVGGroup, item, itemGroup, transition) {
			var windowStart = ctrl.getXCoordinateFromTime($scope.tcTimeFrom);
			var windowEnd = ctrl.getXCoordinateFromTime($scope.tcTimeTo);
			
			var height = ctrl.getYCoordinateFromValue(item.value, axisGroup.index, 0);
			var color = item.color;

			var points = '';
			if (item.type === IntervalType) {
				itemGroup.on('mouseover', function() {eventItemMouseoverHandler(itemGroup, axisSVGGroup);})
					.on('mouseout', function() {eventItemMouseoutHandler(itemGroup);});
				var intervalElement = TimelineService.getOrCreateSvgElementByType('polygon', itemGroup)
					.classed('intervalBar', true)
					.attr('stroke-width', dimensions.barBorder);
			
				var start = ctrl.getXCoordinateFromTime(item.startTime);
				var end = ctrl.getXCoordinateFromTime((item.endTime === '') ? $scope.tcTimeNow : item.endTime);
				var thickness = dimensions.barThickness + dimensions.barBorder;
				var width = Math.max(end - start, 1);
				var arrow = width + thickness;
			
				if (item.endTime === '') {
					// Interval is ongoing, draw a rectangle with an arrow	
					points = '0,0 ' + width + ',0 ' + arrow + ',' + thickness / 2 + ' ' + width + ',' + thickness + ' 0,' + thickness;
					intervalElement.attr('points', points)
						.attr('transform', 'translate(' + start + ', ' + (height - thickness / 2) + ')')
						.attr('fill', color)
						.transition(transition);
				} else {
					// Interval has an end date, draw a rectangle 
					points = '0,0 ' + width + ',0 ' + width + ',' + thickness + ' 0,' + thickness;
					intervalElement.attr('points', points)
						.attr('transform', 'translate(' + start + ', ' + (height - thickness / 2) + ')')
						.attr('fill', color)
						.transition(transition);
				}
				
				var labelData = {
					value: item.value,
					labelX: start	
				};
				var labelOptions = {};
				if (($scope.viewModel.showLabels) && (start < windowEnd) && (end > windowStart)) {
					// draw labels for visible items
					labelOptions = {
						show: true,
						target: {
							x: start,
							y: (height - thickness / 2)
						},
						caption: item.caption,
						borderClass: 'labelBorder',
						textClass: 'eventLabelText'
					};
					if (start < 0) {
						labelData.labelX = windowStart;
						labelOptions.target.x = windowStart;
						labelOptions.showLine = false;
						labelOptions.arrowRatio = 1;
					} else {
						labelOptions.showLine = true;
						labelOptions.arrowRatio = 0;
					}
				} else {
					// otherwise, hide the label
					labelOptions = {
						show: false
					};
				}
				showHideItemLabel(itemGroup, labelData, axisGroupModel.labelData, labelOptions);
			} else if (item.type === EventType) {
				// Item is an event, draw a diamond for each event item
				var size = dimensions.markerSize + 1.4 * dimensions.markerBorder;
				var densityRatio = Math.max(0, Math.min(1, dimensions.densityMarkerOverlapRatio));				
				points = '0,' + (size / 2) + ' ' + (size / 2) + ',0 0,' + (-size / 2) + ' ' + (-size / 2) + ',0';
				
				var eventItemGroups = itemGroup
					.selectAll('g.eventItemGroup')
					.data(item.displayItems, function(d) {return d.eventTime;});
					
				eventItemGroups.enter()
					.append('g')
					.attr('id', function(d) {return getEventItemGroupId(d, itemGroup);})
					.attr('class', 'eventItemGroup')
					.each(function() {
						var eventItemGroup = d3.select(this);
						eventItemGroup
							.on('mouseover', function() {eventItemMouseoverHandler(eventItemGroup, itemGroup);})
							.on('mouseout', function() {eventItemMouseoutHandler(eventItemGroup);})
							.append(function(d) { return createIndicator(d, points, densityRatio, size);})
							.attr('class', 'eventMarker')
							.attr('stroke-width', dimensions.markerBorder);						
					})
				.merge(eventItemGroups)
					.transition(transition)
					.each(function(d) {
						var color = item.color;
						if (d.eventCode == 'CAREEVENT') {
							color = d.color;
						}
						var time = ctrl.getXCoordinateFromTime(d.eventTime);
						
						var eventItemGroup = d3.select(this);
						eventItemGroup.select('g') 
							.attr('transform', 'translate(' + time + ', ' + height + ')');
						
						eventItemGroup // Modify the back diamond
							.select('.back')
							.attr('class', function(d) {return getBackDiamondClass(d, color);})
							.attr('fill', function() {return getFillColor(color);});
							
						eventItemGroup // Modify the front diamond
							.select('.front')
							.attr('class', function(d) {return getFrontDiamondClass(d, color);})
							.attr('fill', function() {return getFillColor(color);});
						
						var labelData = {
							value: item.value,
							labelX: time
						};
						var labelOptions = {};
						if (($scope.viewModel.showLabels) && (time < windowEnd) && (time > windowStart)) {
							// draw labels for visible items
							labelOptions = {
								show: true,
								target: {
									x: time,
									y: (height - size / 2)
								},
								caption: d.caption,
								borderClass: 'labelBorder',
								textClass: 'eventLabelText',
								showLine: true,
								arrowRatio: 0
							};
						} else {
							// otherwise, hide the label
							labelOptions = {
								show: false
							};
						}
						showHideItemLabel(eventItemGroup, labelData, axisGroupModel.labelData, labelOptions);
					});
				
				eventItemGroups.exit()
					.each(function() {
						// remove label data for points that are no longer being displayed
						var eventItemGroup = d3.select(this);
						
						var valueData = axisGroupModel.labelData[item.value];
						var labelGroupId = getLabelGroupId(eventItemGroup);
						
						removeLabelData(valueData, labelGroupId);
					})
					.remove();
			}

			if ($scope.data.profileType === TimelineService.EventTimelineType) {
				axisGroup.toggleItemVisibility(item, true);
			}
		};
		
		return drawAxisItemData;
	};
	
	this.getRemoveAxisItem = function($scope, ctrl, axisGroup) {
		var removeAxisItem = function(item, itemGroup) {
			// remove label data for items that are no longer being displayed
			var valueData = $scope.viewModel.axisGroupModel[axisGroup.index].labelData[item.value];
			
			if (item.type === IntervalType) {
				var labelGroupId = getLabelGroupId(itemGroup);
			
				removeLabelData(valueData, labelGroupId);
			} else if (item.type === EventType) {
				angular.forEach(item.displayItems, function(eventItem) {
					var eventItemGroup = itemGroup.select('#' + getEventItemGroupId(eventItem, itemGroup));
					var labelGroupId = getLabelGroupId(eventItemGroup);
					
					removeLabelData(valueData, labelGroupId);
				});
			}
		};
		
		return removeAxisItem;
	};
	
	var adjustLabelClipPaths = function(labelData) {
		for (var value in labelData) {
			var valueData = labelData[value];
			for (var i = 0; i < valueData.length; i++) {
				// check if this label is close enough to the next to be truncated
				adjustLabelClipPath(valueData[i], valueData[i + 1]);
			}
		}
	};
		
	var adjustLabelClipPath = function(leftLabelData, rightLabelData) {
		var clipPathRect = d3.select('#' + leftLabelData.labelGroupId + ' > clipPath > rect');
		if (clipPathRect.empty()) return;
		var labelShape = d3.select('#' + leftLabelData.labelGroupId + ' > g > polygon');
		if (labelShape.empty()) return;
		
		var clipPathWidth = labelShape.node().getBoundingClientRect().width;
		if (angular.isDefined(rightLabelData)) {
			clipPathWidth = Math.min(rightLabelData.labelX - leftLabelData.labelX, clipPathWidth);
		}
		clipPathRect.attr('width', clipPathWidth);
	};
		
	this.serviceOnUpdateAxis = function($scope, ctrl, axisGroup) {
		if ($scope.viewModel.showLabels) adjustLabelClipPaths($scope.viewModel.axisGroupModel[axisGroup.index].labelData);
	};

	this.getVisibleHandler = function($scope) {
		// for an event timeline, when a legend category's visibility is toggled,
		// make sure all items under that category have the same visibility
		var VisibleHandler = function(legendCategory) {
			angular.forEach(legendCategory.items, function(item) {
				item.visible = legendCategory.visible;
			});
		};

		var DefaultVisibleHandler = function() { return; };
		
		if ($scope.data.profileType === TimelineService.EventTimelineType) {
			return VisibleHandler;
		}
		
		return DefaultVisibleHandler;
	};

	this.getLegendItemsHandler = function($scope) {
		// for an event timeline, use the event categories to create legend categories (not the axes)
		var LegendItemsHandler = function() {
			var items = [];
			angular.forEach($scope.data.eventCategories, function(category) {
				items.push(category);
				$scope.linkLegendCategoriesToItems();
			});
			return items;
		};

		var DefaultLegendItemsHandler = $scope.getDefaultLegendItems;
		
		if ($scope.data.profileType === TimelineService.EventTimelineType) {
			return LegendItemsHandler;
		}
		
		return DefaultLegendItemsHandler;
	};
});
